import { InferGetStaticPropsType, NextPage } from "next"
import React from "react"
import { STATIC_PAGE_REVALIDATE_INTERVAL } from "../constants/application-settings"
import { AlbumGallery } from "../components/album"
import { Text, Title } from "../components/typography"
import { useTranslation } from "react-i18next"
import { Seo } from "../components/seo"
import { IAlbum } from "../interfaces/models"
import { getAllAlbums } from "../../lib/catalog/albums"

export const getStaticProps = async () => {
  let error: any = null
  let albums: IAlbum[] = []

  try {
    albums = await getAllAlbums()
  } catch (e: any) {
    error = e
  }

  return {
    props: {
      error,
      albums,
    },
    revalidate: STATIC_PAGE_REVALIDATE_INTERVAL,
  }
}

const AlbumListPage: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ albums }) => {
  const { t } = useTranslation()

  return (
    <>
      <Seo
        title={t("seo:albumList.title")}
        description={t("seo:albumList.description")}
      />
      <div className="text-center my-6">
        <div className="text-center my-6">
          <Title>{t("label:albumListPageTitle")}</Title>
          <Text type="secondary">{t("label:albumListPageSubtitle")}</Text>
        </div>

        <AlbumGallery data={albums} />
      </div>
    </>
  )
}

export default AlbumListPage
